import ods1 from "../../assets/img/ods/ods1.svg"
import ods2 from "../../assets/img/ods/ods2.svg"
import ods3 from "../../assets/img/ods/ods3.svg"
import ods4 from "../../assets/img/ods/ods4.svg"
import ods5 from "../../assets/img/ods/ods5.svg"
import ods6 from "../../assets/img/ods/ods6.svg"
import ods7 from "../../assets/img/ods/ods7.svg"
import ods8 from "../../assets/img/ods/ods8.svg"
import ods9 from "../../assets/img/ods/ods9.svg"
import ods10 from "../../assets/img/ods/ods10.svg"
import ods11 from "../../assets/img/ods/ods11.svg"
import ods12 from "../../assets/img/ods/ods12.svg"
import ods13 from "../../assets/img/ods/ods13.svg"
import ods14 from "../../assets/img/ods/ods14.svg"
import ods15 from "../../assets/img/ods/ods15.svg"
import ods16 from "../../assets/img/ods/ods16.svg"
import ods17 from "../../assets/img/ods/ods17.svg"
import "./styles.scss"

export const imgODSList = [
  ods1,
  ods2,
  ods3,
  ods4,
  ods5,
  ods6,
  ods7,
  ods8,
  ods9,
  ods10,
  ods11,
  ods12,
  ods13,
  ods14,
  ods15,
  ods16,
  ods17
]

export const ImgsODS = ({ type = "1", width = 90, height = 90 }) => {
  return (
    <div>
      {type === "1" && <img width={`${width}px`} height={`${height}px`} src={ods1} />}
      {type === "2" && <img width={`${width}px`} height={`${height}px`} src={ods2} />}
      {type === "3" && <img width={`${width}px`} height={`${height}px`} src={ods3} />}
      {type === "4" && <img width={`${width}px`} height={`${height}px`} src={ods4} />}
      {type === "5" && <img width={`${width}px`} height={`${height}px`} src={ods5} />}
      {type === "6" && <img width={`${width}px`} height={`${height}px`} src={ods6} />}
      {type === "7" && <img width={`${width}px`} height={`${height}px`} src={ods7} />}
      {type === "8" && <img width={`${width}px`} height={`${height}px`} src={ods8} />}
      {type === "9" && <img width={`${width}px`} height={`${height}px`} src={ods9} />}
      {type === "10" && <img width={`${width}px`} height={`${height}px`} src={ods10} />}
      {type === "11" && <img width={`${width}px`} height={`${height}px`} src={ods11} />}
      {type === "12" && <img width={`${width}px`} height={`${height}px`} src={ods12} />}
      {type === "13" && <img width={`${width}px`} height={`${height}px`} src={ods13} />}
      {type === "14" && <img width={`${width}px`} height={`${height}px`} src={ods14} />}
      {type === "15" && <img width={`${width}px`} height={`${height}px`} src={ods15} />}
      {type === "16" && <img width={`${width}px`} height={`${height}px`} src={ods16} />}
      {type === "17" && <img width={`${width}px`} height={`${height}px`} src={ods17} />}
    </div>
  )
}
